
import Vue from 'vue'
import { VBtn, VSnackbar } from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcFlashMessage',
  components: { VSnackbar, VBtn },
  props: {
    type: { type: String, default: '', required: true },
    text: { type: String, default: '' },
    timeout: { type: Number, default: 5000 },
    value: { type: Boolean, default: false },
  },
  data() {
    return { snackbar: this.value }
  },
  watch: {
    type() {
      if (this.type) {
        this.snackbar = true
      }
    },
    snackbar() {
      if (this.snackbar == false) {
        this.$nextTick(() => {
          this.$store.commit('CLEAR_RESPONSE')
        })
      }
    },
  },
  methods: {
    saveMsg(x) {
      if (this.text) {
        return this.text
      }
      switch (x) {
        case 'success':
          return 'Your changes have been saved.'
        case 'error':
          return 'An error has occurred. Your changes have not been saved.'
        default:
          return ''
      }
    },
  },
})
